import type { Action } from 'redux'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import type { StreamDefinition } from '../../signalr/types'
import { customerAddCustomer } from './actions'
import type { Customer } from './types'

export const fetchCustomerDefinition: StreamDefinition<[], Customer[], Action> =
  {
    method: 'GetCustomers',
    strategy: 'switch',
    getParams,
    mapResponse: customerAddCustomer,
    errorAction: 'customers.fetchFail',
    cancelOn: []
  }
